import React from "react";
import Image from "../Images/Founder-1.jpeg";
import "../CSS/Founder.css";
import { FaGraduationCap, FaRunning, FaChalkboardTeacher } from 'react-icons/fa';

const Founder = () => {

    const startDate = new Date("2005-01-15");
    const currentDate = new Date();
  
    // Calculate the years of experience
    const yearsOfExperience = currentDate.getFullYear() - startDate.getFullYear();
    const isAnniversaryPassed =
      currentDate.getMonth() > startDate.getMonth() ||
      (currentDate.getMonth() === startDate.getMonth() &&
        currentDate.getDate() >= startDate.getDate());
    const totalExperience = isAnniversaryPassed ? yearsOfExperience : yearsOfExperience - 1;
  
    return (
        <>
            <div className="foundersection1">
                <h1 className="text-center p-4">Founder</h1>
                <div className="container mt-5">
                    <div className="row block-9 founder-container">
            
                        <div className="col-md-4 founder-image">
                            <img src={Image} alt="founder" />
                        </div>
                      
                        <div className="col-md-8 founder-info">
                            <div className="founderinfo mb-4">
                                <h3 className="text-left founderh3">K.Balaji</h3>
                                <h6 className="text-left founderh4 mb-4 text-white">
                                    <FaGraduationCap /> B.Tech, NIS, BWF
                                </h6>
                                <p className="text-white founderinfop">{totalExperience} years Experience in the Badminton Game. I have achieved various titles and for past 7 years, I have been coaching players from across the State. I dedicated their life to mastering the game and sharing their expertise with aspiring players. Known for their unparalleled passion and commitment, they have become a beacon of inspiration for players of all ages and skill levels. </p>
                               
                                <div className="experience-cards">
                                   
                                    {/* <div className="experience-card glassmorphismfounder1">
                                        <h5 className="text-center foundercup"><FaGraduationCap/></h5>
                                        <h6>Years of Experience as Player</h6>
                                        <h5 className="founderh5">14 Years</h5>
                                    </div>
                                 
                                    <div className="experience-card glassmorphism12">
                                        <h5 className="text-center foundercup"><FaChalkboardTeacher/></h5>
                                        <h6>Years of Experience as Coach</h6>
                                        <h5  className="founderh5">8 Years</h5>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Founder;
